function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './KDramaMap.css';
import React, { useEffect, useRef } from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { canUseDOM } from 'react-helmet';
import RouterLink from '../atoms/RouterLink';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { ReactComponent as IconClickThrough } from '../../resources/icons/IconClickThrough.svg';
import { ReactComponent as IconPin } from '../../resources/icons/pin.svg';
import { ReactComponent as ArrowRight } from '../../resources/icons/icon-chevron-right-v1.svg';
import { ReactComponent as ArrowLeft } from '../../resources/icons/icon-chevron-left-v1.svg';
import { ReactComponent as IconChevronDown } from '../../resources/icons/arrowDownB.svg';
import GoogleMap, { defaultMapState, googleMapDirectionLink } from '../atoms/GoogleMaps/GoogleMaps';
import { useInView } from 'react-intersection-observer';
import ScrollAnimation from 'react-animate-on-scroll';
import OSM from '../atoms/OpenStreetMap/OpenStreetMap';
import { get, getDictionaryItem, getGlobalDictionaryTerm, getPageThemeColors, getColorByTheme, injectImageResolution, pathJoin, getMediaHost } from '../../utils';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import Switch from './components/Switch';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import LazyPicture from '../atoms/LazyPicture';
const ZOOM_LEVEL = 2;
export const KDramaMap = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const newWindowLabel = getGlobalDictionaryTerm(sitecoreContext, 'newWindowLabel') || 'Opens in a new window';
  const closeLabel = getGlobalDictionaryTerm(sitecoreContext, 'close') || 'Close';
  const nextArrowLabel = getGlobalDictionaryTerm(sitecoreContext, 'nextArrowLabel') || 'Next slide';
  const prevArrowLabel = getGlobalDictionaryTerm(sitecoreContext, 'prevArrowLabel') || 'Previous slide';
  const currentLang = get(sitecoreContext, 'language');
  const googleApiKey = get(sitecoreContext, 'configuration.google.apiKey', '');
  const [ref, inView] = useInView({
    rootMargin: '100px 0px 100px 0px',
    triggerOnce: true
  });
  const targetItems = get(fields, 'data.item.locations.targetItems');
  const neighborhoods = get(fields, 'data.item.neighborhoods.values');
  const [uniqueTags, setUniqueTags] = React.useState([]);
  const [selectedTag, setSelectedTag] = React.useState('');
  const [neighborhoodsFiltred, setNeighborhoodsFiltred] = React.useState(neighborhoods);
  const title = get(fields, 'data.item.title.jss');
  const [isVdsite, setIsVdsite] = React.useState(true);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  React.useEffect(() => {
    const names = new Set();
    neighborhoods.forEach(el => {
      get(el, 'tags.targetItems', []).forEach(el => {
        names.add(get(el, 'fullName.value'));
      });
    });
    setUniqueTags([AllText, ...names]);
  }, [neighborhoods]);
  React.useEffect(() => {
    const filtredNeighborhoods = neighborhoods.filter(el => {
      let filtered = false;
      get(el, 'tags.targetItems').forEach(el => {
        if (get(el, 'fullName.value') === selectedTag) {
          filtered = true;
        }
      });
      return !selectedTag || selectedTag === AllText ? true : filtered;
    });
    setNeighborhoodsFiltred(filtredNeighborhoods);
    if (selectedTag) {
      const title = get(filtredNeighborhoods[0], 'title.jss.value') || get(filtredNeighborhoods[0], 'name.jss.value');
      const introText = get(filtredNeighborhoods[0], 'introText.jss.value');
      const url = get(filtredNeighborhoods[0], 'url') || get(filtredNeighborhoods[0], 'link.jss.value.href');
      setActiveItem(1);
      updateState(title, introText, url, 0);
      pushLocations(filtredNeighborhoods);
    }
  }, [selectedTag]);
  const selectTag = tag => {
    setSelectedTag(tag);
  };
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const primaryColor = BackgroundColorHex ? BackgroundColorHex : selectedPrimaryColor;
  const variables = BackgroundColorHex ? {
    '--m60-KDramaMap-primary-color': BackgroundColorHex,
    '--m60-KDramaMap-active-color': ActiveColorHex,
    '--m60-KDramaMap-color': ColorHex
  } : {
    '--m60-KDramaMap-primary-color': selectedPrimaryColor,
    '--m60-KDramaMap-active-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    '--m60-KDramaMap-color': getColorByTheme(selectedPrimaryColor)
  };
  const introText = get(fields, 'data.item.introText.jss');
  const dictionary = get(fields, 'data.dictionary');
  const [mapState, setMapState] = React.useState(_objectSpread(_objectSpread({}, defaultMapState), {
    centered: false
  }));
  const [currentLat, setcurrentLat] = React.useState(mapState.lat);
  const [currentLng, setcurrentLng] = React.useState(mapState.lng);
  const [infoTitle, setInfoTitle] = React.useState('');
  const [mediaAssets, setMediaAssets] = React.useState(['']);
  const [infoIntroText, setInfoIntroText] = React.useState('');
  const [activeItem, setActiveItem] = React.useState(1);
  const [showInfo, setShowInfo] = React.useState(false);
  const [url, setUrl] = React.useState('');
  const [highLightDrop, setHighLightDrop] = React.useState(false);
  const clickedDropRef = React.useRef(false);
  const mapRef = useRef();
  const JumpToSection = getDictionaryItem(dictionary, 'JumpToSection');
  const LearnMore = getDictionaryItem(dictionary, 'LearnMore');
  const AllText = getDictionaryItem(dictionary, 'All');
  const placeInfoRef = React.useRef(null);
  let firstItem;
  let validLocations = [];
  const [isChina, setIsChina] = React.useState(false);
  const isKDramaMap = true;
  const {
    learnMoreClickAnalytics,
    mapOptionsAnalytics,
    learnMoreCloseAnalytics,
    locationClickAnalytics
  } = fields.data;
  useEffect(() => {
    const urlParams = new URLSearchParams(document.location.search);
    const isC = Boolean(urlParams.get('isChina') === 'true');
    setIsChina(isC);
  });
  const [inWindowView, setInWindowView] = React.useState(false);
  React.useEffect(() => {
    setInWindowView(inView);
  }, [inView]);
  if (!fields) {
    console.warn('KDramaMap component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [KDramaMap component is empty: please provide data source]");
    }
    return null;
  }
  const selectedLocation = e => {
    const [title, url, intro, index] = getDataAttributes(e.target.selectedOptions[0]);
    updateState(title, intro, url, Number(index - 1));
    tealiumClickFunc(tealiumMergeClickData(locationClickAnalytics, params), title);
  };
  const handleDropMousedown = () => {
    clickedDropRef.current = true;
  };
  const handleDropFocus = () => {
    if (!clickedDropRef.current) {
      setHighLightDrop(true);
    }
  };
  const handleDropBlur = () => {
    clickedDropRef.current = false;
    setHighLightDrop(false);
  };
  const selectedLocationFromList = e => {
    const [title, url, intro, index] = getDataAttributes(e.currentTarget);
    setActiveItem(Number(index));
    // add additional parameters to updateState for centering the map
    updateState(title, intro, url, Number(index - 1), null, true);
    tealiumClickFunc(tealiumMergeClickData(locationClickAnalytics, params), title);
  };
  const getDataAttributes = item => {
    const title = item.getAttribute('data-title');
    const url = item.getAttribute('data-url');
    const intro = item.getAttribute('data-intro');
    const index = item.getAttribute('data-index');
    return [title, url, intro, index];
  };
  const pushLocations = validLocations => {
    let markers = [];
    validLocations.map((location, Index) => {
      // + convert string (latitude, longitude) to number
      const lat = +get(location, 'latitude.jss.value');
      const lng = +get(location, 'longitude.jss.value');
      const title = get(location, 'title.jss.value') || get(location, 'name.jss.value');
      markers.push({
        title,
        lat,
        lng
      });
      setMapState({
        lat,
        lng,
        activeMarker: 0,
        markers,
        centered: false
      });
      if (validLocations.length === markers.length) {
        setMapState({
          lat,
          lng,
          activeMarker: 0,
          markers,
          centered: true
        });
      }
    });
  };
  const updateState = (infoTitle, infoIntro, url, index, center, centered) => {
    const selectedItem = neighborhoods.filter(el => {
      return get(el, 'name.jss.value', '') === infoTitle;
    });
    setMediaAssets(get(selectedItem[0], 'images.targetItems'));
    setInfoTitle(infoTitle);
    setInfoIntroText(infoIntro);
    setUrl(url);
    const marker = mapState.markers[index];
    const markers = mapState.markers.map((e, i) => {
      if (Object.keys(e).length) if (i === index) e.centered = centered || false;else e.centered = false;
      return e;
    });
    const lat = marker.lat;
    const lng = marker.lng;
    setMapState(_objectSpread(_objectSpread({}, mapState), {}, {
      activeMarker: index,
      lat: center && center.lat || lat,
      lng: center && center.lng || lng,
      markers
    }));
    setcurrentLat(lat);
    setcurrentLng(lng);
    if (!infoTitle && !infoIntro && !url) {
      setShowInfo(false);
    } else {
      setShowInfo(true);
    }
  };
  const renderLocations = (targetItems, renderTarget) => {
    let items;
    let counter = 0;
    validLocations = [];
    if (targetItems) {
      items = targetItems.map((item, index) => {
        const lat = get(item, 'latitude.jss.value');
        const lng = get(item, 'longitude.jss.value');
        const address = get(item, 'title.jss.value') || get(item, 'name.jss.value');
        const googlePlaceId = get(item, 'googlePlaceID.value') || get(item, 'googlePlaceID.jss.value');
        const title = get(item, 'title.jss.value') || get(item, 'name.jss.value');
        const introText = get(item, 'introText.jss.value');
        const url = get(item, 'url') || get(item, 'link.jss.value.href');
        const animationFactor = 0.5;
        if (lat || lng || googlePlaceId) {
          if (address) {
            //first valid item
            validLocations.push(item);
            counter++;
            if (!firstItem) {
              firstItem = {
                lat,
                lng,
                address,
                googlePlaceId,
                title,
                introText,
                url
              };
            }
            if (targetItems.length <= 1) {
              return null;
            }
            if (renderTarget === 'mobile') {
              return /*#__PURE__*/React.createElement("option", {
                key: index,
                className: "dropdown-primary__opt",
                "data-lat": lat,
                "data-lng": lng,
                "data-index": counter,
                "data-placeid": googlePlaceId,
                "data-address": address,
                "data-title": title,
                "data-url": url,
                "data-intro": introText
              }, address);
            } else {
              return /*#__PURE__*/React.createElement("div", {
                key: index,
                className: "location-item"
              }, /*#__PURE__*/React.createElement(ScrollAnimation, {
                animateIn: "animate__fadeInUp",
                animateOnce: true,
                duration: 0.5,
                delay: index * 25
              }, /*#__PURE__*/React.createElement("button", {
                type: "button",
                className: `mml__location-item ${counter === activeItem ? 'mml__location-item--active' : ''}`,
                "data-lat": lat,
                "data-index": counter,
                "data-lng": lng,
                "data-placeid": googlePlaceId,
                "data-address": address,
                "data-title": title,
                "data-url": url,
                "data-intro": introText,
                onClick: e => {
                  selectedLocationFromList(e);
                }
              }, /*#__PURE__*/React.createElement("div", {
                className: "pin"
              }, /*#__PURE__*/React.createElement(IconPin, {
                className: "mml__location-icon"
              }), /*#__PURE__*/React.createElement("div", {
                className: "mml__location-num"
              }, counter)), /*#__PURE__*/React.createElement("span", {
                className: "body-small mml__location-title"
              }, address))));
            }
          }
        }
      });
    }
    return items;
  };
  const markerCallback = (marker, center, centered) => {
    if (validLocations.length > 1) {
      var textMarker;
      if (isChina) {
        const htmlMarker = marker.target.options.icon.options.html;
        const iconNum = new DOMParser().parseFromString(htmlMarker, 'text/html').querySelector('.mml__location-num');
        if (iconNum) textMarker = Number(iconNum.innerHTML);
      }
      if (!isChina) textMarker = marker.label.text;
      const item = validLocations[textMarker - 1];
      const title = get(item, 'title.jss.value') || get(item, 'name.jss.value');
      const introText = get(item, 'introText.jss.value');
      const url = get(item, 'url') || get(item, 'link.jss.value.href');
      const index = textMarker - 1;
      updateState(title, introText, url, index, center, centered);
      setActiveItem(Number(textMarker));
    }
  };
  const ButtonGroup = props => {
    const {
      carouselState: {
        currentSlide,
        totalItems
      },
      goToSlide
    } = props;
    if (totalItems > 1) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "navigation-container"
      }, /*#__PURE__*/React.createElement("button", {
        className: `my-icon-white carousel-icon carousel-icon-left ${currentSlide === 0 ? 'carousel-icon--inactive' : ''}`,
        disabled: currentSlide === 0,
        onClick: () => {
          props.previous();
        },
        "aria-label": prevArrowLabel,
        title: prevArrowLabel
      }, /*#__PURE__*/React.createElement(ArrowLeft, null)), /*#__PURE__*/React.createElement("button", {
        className: `my-icon-white carousel-icon carousel-icon-right ${currentSlide >= totalItems - 1 ? 'carousel-icon--inactive' : ''}`,
        disabled: currentSlide >= totalItems - 1,
        onClick: () => {
          props.next();
        },
        "aria-label": nextArrowLabel,
        title: nextArrowLabel
      }, /*#__PURE__*/React.createElement(ArrowRight, null))), /*#__PURE__*/React.createElement("div", {
        className: "dot-container"
      }, Array.from(Array(totalItems).keys()).map(index => /*#__PURE__*/React.createElement("div", {
        tabIndex: currentSlide === index ? -1 : 0,
        key: index,
        className: `dot ${currentSlide === index ? 'dot--active' : ''}`,
        onClick: () => {
          goToSlide(index);
        }
      }))));
    }
    return null;
  };
  const apiReady = googleMapRef => {
    const title = get(validLocations[0], 'title.jss.value') || get(validLocations[0], 'name.jss.value');
    const introText = get(validLocations[0], 'introText.jss.value');
    const url = get(validLocations[0], 'url') || get(validLocations[0], 'link.jss.value.href');
    updateState(title, introText, url, 0);
    pushLocations(validLocations);
    mapRef.current = googleMapRef.current.map;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "container",
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mml"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mml__info"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: "mml__info-title",
    field: title
  })), /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.2
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "mml__info-introText",
    field: introText
  })), uniqueTags.length ? /*#__PURE__*/React.createElement(Switch, {
    tagsToDisplay: uniqueTags,
    selectTag: selectTag,
    rtl: rtl
  }) : null), /*#__PURE__*/React.createElement("div", {
    className: "mml__outer-wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mml__iframe-wrap mml__iframe-wrap--popup mml__map"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mml__iframe",
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    ref: placeInfoRef,
    id: "place-info"
  }), !isChina && inWindowView && /*#__PURE__*/React.createElement(GoogleMap, {
    language: currentLang,
    mapKey: googleApiKey,
    zoom: 14,
    maxZoomActive: true,
    allowZoomControl: false,
    customMarker: true,
    isCenterOnMarkerClick: true,
    zoomedLevel: ZOOM_LEVEL,
    callback: apiReady,
    markerCallback: markerCallback,
    mapState: mapState,
    theme: _objectSpread(_objectSpread({}, get(sitecoreContext, 'themesOfPage')), {
      primary: '#525252',
      primary_active: primaryColor
    }),
    mapMarkerZoomOut: true,
    isKDramaMap: isKDramaMap,
    cameraControlPosition: rtl ? 'LEFT_TOP' : 'RIGHT_TOP'
  }), isChina && /*#__PURE__*/React.createElement(OSM, {
    zoom: 12,
    customMarker: true,
    callback: apiReady,
    markerCallback: markerCallback,
    mapState: mapState
  })), /*#__PURE__*/React.createElement("div", {
    className: "mml__controls"
  }, /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    rel: "noopener noreferrer",
    href: googleMapDirectionLink(currentLat, currentLng),
    className: "mml__controls-btn",
    onClick: () => tealiumClickFunc(tealiumMergeClickData(mapOptionsAnalytics, params), 'Return'),
    title: `Route | ${newWindowLabel}`,
    "aria-label": `Route | ${newWindowLabel}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-icon-white"
  }, /*#__PURE__*/React.createElement(IconClickThrough, {
    className: "icon"
  }))))), showInfo && /*#__PURE__*/React.createElement("div", {
    className: "mml__popup active"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mml__image-container-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: `mml__image-container`
  }, mediaAssets.length ? /*#__PURE__*/React.createElement(CarouselProvider, null, _ref2 => {
    let {
      renderCarousel
    } = _ref2;
    return /*#__PURE__*/React.createElement(React.Fragment, null, renderCarousel(mediaAssets.map(item => {
      const deskImg = injectImageResolution(pathJoin([getMediaHost(), item.url]), 580, 420);
      const mobImg = injectImageResolution(pathJoin([getMediaHost(), item.url]), 325, 212);
      return /*#__PURE__*/React.createElement(LazyPicture, {
        useEmptyPlaceholder: true,
        hover: true,
        key: deskImg
      }, /*#__PURE__*/React.createElement("source", {
        media: "(min-width: 992px)",
        srcSet: deskImg
      }), /*#__PURE__*/React.createElement("img", {
        className: "mml__image",
        src: mobImg,
        alt: item.name
      }));
    }), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 0
          },
          items: 1
        }
      },
      customButtonGroup: /*#__PURE__*/React.createElement(ButtonGroup, null),
      containerClass: 'mmlCarouselContainer',
      swipeable: true,
      draggable: true
    }));
  }) : null)), /*#__PURE__*/React.createElement("div", {
    className: "mml__popup-text-container"
  }, /*#__PURE__*/React.createElement("p", {
    className: "body-medium mml__popup-title"
  }, infoTitle), /*#__PURE__*/React.createElement("p", {
    className: "mml__popup-para"
  }, infoIntroText), url && /*#__PURE__*/React.createElement(RouterLink, {
    className: "btn btn-primary mml__popup-btn",
    href: url,
    linktype: "external",
    openInSameTab: true,
    onClick: () => tealiumClickFunc(tealiumMergeClickData(learnMoreClickAnalytics, params), infoTitle)
  }, LearnMore))), /*#__PURE__*/React.createElement("div", {
    className: `${targetItems && targetItems.length > 1 || neighborhoodsFiltred && neighborhoodsFiltred.length > 1 ? 'mml__locations-list' : ''}`
  }, targetItems && targetItems.length > 1 || neighborhoodsFiltred && neighborhoodsFiltred.length > 1 ? /*#__PURE__*/React.createElement("div", {
    className: "row d-md-none"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-primary"
  }, /*#__PURE__*/React.createElement("select", {
    className: `
                                      dropdown-primary__select mml__select js-listbox-item
                                      ${highLightDrop ? 'dropdown-primary__select--focused' : ''}
                                    `,
    onChange: selectedLocation,
    placeholder: JumpToSection,
    "aria-label": JumpToSection,
    onMouseDown: handleDropMousedown,
    onFocus: handleDropFocus,
    onBlur: handleDropBlur
  }, /*#__PURE__*/React.createElement("optgroup", {
    title: "locations group",
    "aria-label": "locations group"
  }, targetItems && renderLocations(targetItems, 'mobile'), neighborhoodsFiltred && renderLocations(neighborhoodsFiltred, 'mobile'))), /*#__PURE__*/React.createElement(IconChevronDown, {
    className: "icon selectArrow"
  })))) : /*#__PURE__*/React.createElement(React.Fragment, null, targetItems && renderLocations(targetItems, 'mobile'), neighborhoodsFiltred && renderLocations(neighborhoodsFiltred, 'mobile')), /*#__PURE__*/React.createElement("div", {
    className: "row d-none d-md-block mml__locations-list__row"
  }, targetItems && targetItems.length > 1 || neighborhoodsFiltred && neighborhoodsFiltred.length > 1 ? /*#__PURE__*/React.createElement("div", {
    className: "map-list-location"
  }, targetItems && renderLocations(targetItems, 'desktop'), neighborhoodsFiltred && renderLocations(neighborhoodsFiltred, 'desktop')) : null)))))))))))));
};
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref3;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    minHeight: true,
    className: `${rtl ? rtlStyles : ltrStyles} ${commonStyles}`
  }, children);
};
export const commonStyles = "cr49tyn";
export const ltrStyles = "lig86jk";
export const rtlStyles = "r14gyzp8";
export default KDramaMap;